import { render, staticRenderFns } from "./accountKS.vue?vue&type=template&id=f54d5c9e&scoped=true"
import script from "./accountKS.vue?vue&type=script&lang=js"
export * from "./accountKS.vue?vue&type=script&lang=js"
import style0 from "./accountKS.vue?vue&type=style&index=0&id=f54d5c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54d5c9e",
  null
  
)

export default component.exports